import React from 'react';
import nb from './nb.json';
import de from './de.json';
import en from './en.json';
import da from './da.json';
import nl from './nl.json';
import { Select } from '../Select';
/** Countries to be at the top of the list */
const FEATURED_LANGUAGES = ['NO', 'DK', 'DE', 'NL', 'SE'];
/** Sort with Alphabetical Order */
const sortAlphabetical = (option, compareOption) => option.label.localeCompare(compareOption.label);
const itemsTopSort = (list, nationalitySortList) => {
    const topItems = nationalitySortList
        .map((nationality) => ({
        ...list.find((option) => nationality === option.value),
        key: `featured-language-${nationality}`,
    }))
        .filter((item) => !!item);
    if (topItems.length > 0) {
        topItems.push({ disabled: true, value: 'line-sep', label: '- - - - - - - - - - - - - - - -' });
    }
    return [...topItems, ...list];
};
/** This function returns an alphabetical sorted list of nationalities with specific countries at its top */
const sortedData = (list, nationalitySortList) => {
    const mappedList = list
        .map(([isoCode, nationality]) => ({
        label: nationality,
        value: isoCode,
    }))
        .filter((item) => !!item);
    const sortedAlpha = mappedList.sort(sortAlphabetical);
    return itemsTopSort(sortedAlpha, nationalitySortList);
};
const options = {
    en: sortedData(Object.entries(en.nationalities), FEATURED_LANGUAGES),
    da: sortedData(Object.entries(da.nationalities), FEATURED_LANGUAGES),
    de: sortedData(Object.entries(de.nationalities), FEATURED_LANGUAGES),
    nl: sortedData(Object.entries(nl.nationalities), FEATURED_LANGUAGES),
    nb: sortedData(Object.entries(nb.nationalities), FEATURED_LANGUAGES),
};
export const NationalitySelect = ({ 'data-cy': testId, errorMessage, label, locale, onChange, placeholder, required, value, disabled, state = "default", }) => {
    if (!options[locale]) {
        throw new Error(`${locale} is not supported`);
    }
    const errorState = state === 'error' || errorMessage;
    return (React.createElement("div", { "data-cy": testId },
        React.createElement(Select, { label: label, onChange: onChange, options: options[locale], optionTitleFn: (option) => option.label, optionValueFn: (option) => option.value, placeholder: placeholder, required: required, state: errorState ? 'error' : 'default', value: value, disabled: disabled })));
};
export default NationalitySelect;
//# sourceMappingURL=NationalitySelect.js.map